export default {
    init() {

        // JavaScript to be fired on all pages
        'use strict';

        var c, currentScrollTop = 0,
            navbar = $('.js-header');

        $(window).scroll(function () {
            var a = $(window).scrollTop();
            var b = navbar.height();

            currentScrollTop = a;

            if (c < currentScrollTop && a > b + b) {
                navbar.addClass('scrollUp');
            } else if (c > currentScrollTop && !(a <= b)) {
                navbar.removeClass('scrollUp');
            }
            c = currentScrollTop;
        });




    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js